import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getToken()}`,
});

const pickField = (data, ...keys) => {
  if (!data || typeof data !== "object") return undefined;
  for (const key of keys) {
    const value = data[key];
    if (value != null && value !== "") return value;
  }
  return undefined;
};

const isTrue = (data, ...keys) =>
  keys.some((key) => data?.[key] === true);

export const translateShippingSyncError = (raw) => {
  const text = String(raw || "").trim();
  const lower = text.toLowerCase();
  if (!text) return "فشل مزامنة الشحن";
  if (lower.includes("failed to fetch") || lower.includes("networkerror") || lower.includes("cors"))
    return "فشل الاتصال بالسيرفر أثناء مزامنة الشحن. جرّب تاني بعد شوية.";
  if (lower.includes("never sent"))
    return "الأوردر ده متبعتش لـ Fincart";
  if (lower.includes("id was not saved") && lower.includes("token"))
    return "الأوردر اتبعت لـ Fincart لكن رقم الشحن مش محفوظ، والسيرفر مش قادر يرجّعه لأن توكن Fincart مش متضبط";
  if (lower.includes("id was not saved") || lower.includes("could not be recovered"))
    return "رقم شحن Fincart مش محفوظ على الأوردر، ومقدرناش نلاقيه على Fincart بالمرجع بتاعنا";
  if (lower.includes("shipment tracking is not assigned") || lower.includes("shipment has not been created"))
    return "الأوردر موجود على Fincart لكن الشحنة لسه مالهاش رقم تتبع";
  if (lower.includes("failed to return tracking"))
    return "Fincart مردش ببيانات التتبع";
  if (lower.includes("token is not configured"))
    return "توكن Fincart مش متضبط على السيرفر (FINCART_TOKEN)";
  if (lower.includes("missing shipping order id"))
    return "رقم شحن Fincart مش محفوظ على الأوردر. المزامنة هتحاول ترجّعه من Fincart لو التوكن متضبط";
  if (lower.includes("timed out") || lower.includes("timeout"))
    return "Fincart اتأخر في الرد. جرّب تاني بعد شوية";
  if (lower.includes("network"))
    return "حصل خطأ شبكة أثناء الاتصال بـ Fincart";
  if (lower.includes("rate limited") || lower.includes("429"))
    return "Fincart قافل الطلبات مؤقتاً. جرّب بعد دقيقة";
  if (lower.includes("not found"))
    return "مش لاقي الأوردر على Fincart";
  if (lower.includes("unauthorized") || lower.includes(" 401") || lower.includes(" 403") || lower.includes("returned 401") || lower.includes("returned 403"))
    return "توكن Fincart مرفوض. راجع FINCART_TOKEN على السيرفر";
  return text;
};

export const fetchOrderShipping = async (orderId) => {
  const response = await fetch(`${API_BASE_URL}/Shipping/Order/${orderId}`, {
    headers: authHeaders(),
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || "فشل تحميل بيانات الشحن");
  }
  return await response.json();
};

export const syncOrderShipping = async (orderId) => {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}/Shipping/Sync/${orderId}`, {
      method: "POST",
      headers: authHeaders(),
    });
  } catch (err) {
    throw new Error(translateShippingSyncError(err?.message || "failed to fetch"));
  }

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(
      translateShippingSyncError(
        pickField(data, "error", "Error", "message", "Message") ||
          `فشل مزامنة الشحن (${response.status})`
      )
    );
  }

  const success = isTrue(data, "success", "Success");
  const skipped = isTrue(data, "skipped", "Skipped");
  if (!success) {
    throw new Error(
      translateShippingSyncError(
        pickField(data, "error", "Error", "skipReason", "SkipReason") ||
          (skipped ? "Missing shipping order id" : "فشل مزامنة الشحن")
      )
    );
  }

  return data;
};

export const syncActiveShipping = async () => {
  const response = await fetch(`${API_BASE_URL}/Shipping/SyncActive`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.message || "فشل مزامنة الشحن النشطة");
  }
  return data;
};
